const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/getting-started/ai.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { isCircleAiOnboardingEnabled } from "@circle-react/components/CommunityOnboarding/useIsCircleAiOnboardingEnabled";
import { experimentationFlagsQueryOptions } from "@circle-react/contexts/useExperimentationFlags";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/getting-started/ai")({
  beforeLoad: async ({
    context
  }) => {
    const {
      currentCommunitySettings,
      currentCommunity,
      currentUser
    } = context.punditUserContext ?? {};
    if (!currentCommunity?.id || !currentUser?.id) {
      redirect({
        href: "/getting-started",
        throw: true
      });
      return;
    }
    const isCircleV4 = Boolean(window.V4_UI);

    // The helper is `setting || flag`. We evaluate the two operands in
    // separate calls so we can skip the experimentation-flags fetch when
    // the setting alone is enough to enable onboarding.
    if (isCircleAiOnboardingEnabled({
      currentCommunitySettings
    })) {
      return;
    }
    const flagsResponse = await context.queryClient.ensureQueryData(experimentationFlagsQueryOptions(currentCommunity.id));
    if (isCircleV4 || !isCircleAiOnboardingEnabled({
      experimentationFlags: flagsResponse?.flags
    })) {
      redirect({
        href: "/getting-started",
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});